<template>
  <div>
    <div class="zjgzBox animation srcospcur">
      <img width="100%" :src="list[0].imageUrl" />
      <div class="txt">
        <h3 class="fz44">{{list[0].title}}</h3>
        <div v-html="list[0].content"></div>
      </div>
    </div>
    <div class="zjgz" ref="zjgzDom">
      <ul ref="animation">
        <li
          v-for="(item) in list.slice(1)"
          :key="item.id"
          class="animation srcospcur"
          :class="item.isActive?'cur':''"
          :style="{width: item.isActive?boxw:'56px'}"
          @mouseenter.stop="mouseOverFun(item)"
          @mouseleave.stop="mouseLeaveFun(item)"
        >
          <div class="tits ft24">
            <div class="table">
              <div class="table-cell">{{item.title}}</div>
            </div>
          </div>
          <div class="con" style="width: 640px;" :style="{display:item.isActive?'block':''}">
            <img alt :src="item.imageUrl" style="width: 745px; height: 380px;" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      list: this.$props.data || [],
      boxw: "690px"
    };
  },
  computed: {
    activeNum() {
      let flag = 0;
      this.list.forEach(cell => {
        if (cell.isActive) {
          flag++;
        }
      });
      return flag;
    }
  },
  created() {
    if (this.$props.data.length > 0) {
      let arr = this.$props.data.map(item => {
        item.isActive = false;
        return item;
      });
      arr[1].isActive = true;
      this.$set(this.$data, "list", arr);
    }
  },
  mounted() {
    window.addEventListener("load", () => {
      let cons = document.querySelectorAll(".con");
      let w = this.$refs.zjgzDom.clientWidth;
      cons.forEach(item => {
        item.style.width = w - 280 - 56 + "px";
      });
      this.boxw = w - 280 + "px";
    });
    window.addEventListener("resize", () => {
      let cons = document.querySelectorAll(".con");
      let w = this.$refs.zjgzDom.clientWidth;
      cons.forEach(item => {
        item.style.width = w - 280 - 56 + "px";
      });
      this.boxw = w - 280 + "px";
    });
  },
  methods: {
    mouseOverFun(item) {
      let arr = JSON.parse(JSON.stringify(this.list));
      arr.forEach(cell => {
        if (cell.id == item.id) {
          cell.isActive = true;
        } else {
          cell.isActive = false;
        }
      });
      this.$set(this.$data, "list", arr);
    },
    mouseLeaveFun() {}
  }
};
</script>